// TopRiskyProcesses.jsx
import React from "react";
import CustomBox from "../../../../../Components/UI/CustomBox/CustomBox/CustomBox";
import DetailButton from "../DetectionDetailPopup/DetailButton";
import useDetectionDetailPopup from "../DetectionDetailPopup/useDetectionDetailPopup";

import "./styles.scss";

const TopRiskyProcesses = ({ processes, verdictColor = "#ef5350" }) => {
  const { findProcessDetail, openDetail, popup } = useDetectionDetailPopup();

  if (!processes || processes.length === 0) {
    return (
      <CustomBox className="thunter-risky-processes">
        <h2 className="thunter-risky-processes__title">Top Risky Memory Processes</h2>
        <p className="thunter-risky-processes__empty">No risky memory processes detected</p>
      </CustomBox>
    );
  }

  const getRiskLevel = (score) => {
    if (score > 30) return { text: "High", color: "#d32f2f" };
    if (score > 15) return { text: "Medium", color: "#f57c00" };
    return { text: "Low", color: "#388e3c" };
  };

  return (
    <CustomBox className="thunter-risky-processes">
      <h2 className="thunter-risky-processes__title">Top Risky Memory Processes</h2>

      <div className="thunter-risky-processes__table">
        <div className="thunter-risky-processes__head">
          <div className="thunter-risky-processes__cell thunter-risky-processes__cell--name">
            Process Name
          </div>
          <div className="thunter-risky-processes__cell thunter-risky-processes__cell--score">
            Risk Score
          </div>
          <div className="thunter-risky-processes__cell thunter-risky-processes__cell--level">
            Risk Level
          </div>
        </div>

        <div className="thunter-risky-processes__content">
          {processes.map((process, index) => {
            const riskLevel = getRiskLevel(process.risk_score);
            const processDetail = findProcessDetail({
              process: process.process,
              pid: process.pid,
            });
            return (
              <div key={index} className="thunter-risky-processes__row">
                <div className="thunter-risky-processes__cell thunter-risky-processes__cell--name">
                  {process.process}
                  {processDetail ? (
                    <DetailButton
                      title="Show process details"
                      onClick={() => openDetail(processDetail)}
                    />
                  ) : null}
                </div>
                <div className="thunter-risky-processes__cell thunter-risky-processes__cell--score thunter-risky-processes__cell--bold">
                  {process.risk_score.toFixed(1)}
                </div>
                <div
                  className="thunter-risky-processes__cell thunter-risky-processes__cell--level thunter-risky-processes__cell--bold"
                  style={{ color: riskLevel.color }}>
                  {riskLevel.text}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {popup}
    </CustomBox>
  );
};

export default TopRiskyProcesses;
